import {Box, Tooltip} from "@mui/material";
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const MyEstrelas = ({nota, titulo, totalDeEstrelas =5}) => {

  let color = '#DAA520'

  let estrelas = []
  for (var i = 0; i < totalDeEstrelas; i++) {
    estrelas.push(i+1)
  }

  const  Estrelas  = ({pontos,  numero}) => {
    let inteiro = false
    let meio = false

    if (pontos >= numero) { inteiro = true}
      else if ((pontos - Math.trunc(pontos)> 0 ) && ((Math.trunc(pontos)+1)===numero) ) 
             {meio=true}
     return (
         <>
             {inteiro ? (<StarIcon style={{ color: color }}/>):
                         (meio ? <StarHalfIcon style={{ color: color}} />:<StarBorderIcon style={{ color: color }}/>)}
         </>
         )
  }    

  const  EstrelasVazia  = () => {

    
    return (
            <>
              {
                estrelas.map(estrela => <StarBorderIcon key={estrela} style={{ color: color }}/>)
              }
            </>
          )
  }   

  return (
    <>
      <Tooltip title={titulo} placement="bottom" arrow>
        <Box>

        {
          nota ? 
                estrelas.map((itemNota) => <Estrelas key={itemNota} pontos={nota} numero={itemNota}/> )
            : EstrelasVazia()
        }                            
        </Box>
      </Tooltip>  
    </>
  )
};

export default MyEstrelas;
